import React from 'react';
import { X } from 'lucide-react';
import { Book } from '../../../../../types/Book.types';

export interface BookTypeaheadValue {
  bookId: string | null;
  query: string;
}

interface BookTypeaheadProps {
  books: Book[];
  value: BookTypeaheadValue;
  onChange: (value: BookTypeaheadValue, book?: Book) => void;
  disabled?: boolean;
}

// Mismo buscador que el alta de movimiento en StockAuditReportView: a partir de
// dos caracteres, por título, ISBN o SKU, seis resultados como máximo. Al elegir
// un libro se devuelve el Book para que el padre rellene descripción y SKU.
export const BookTypeahead = ({ books, value, onChange, disabled }: BookTypeaheadProps) => {
  const query = value.query.trim().toLowerCase();
  const selectedBook = value.bookId ? books.find(b => b.id === value.bookId) : undefined;

  const matches = selectedBook || query.length < 2
    ? []
    : books.filter(b =>
        b.title.toLowerCase().includes(query) ||
        (b.isbn || '').toLowerCase().includes(query) ||
        (b.sku || '').toLowerCase().includes(query)
      ).slice(0, 6);

  if (selectedBook) {
    return (
      <div className="purchases-view__book-selected">
        <span>{selectedBook.title}{selectedBook.sku ? ` · ${selectedBook.sku}` : ''}</span>
        {!disabled && (
          <button
            type="button"
            onClick={() => onChange({ bookId: null, query: '' })}
            className="purchases-view__book-clear"
            title="Quitar libro"
          >
            <X size={10} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="purchases-view__book-typeahead">
      <input
        type="text"
        value={value.query}
        disabled={disabled}
        onChange={(e) => onChange({ bookId: null, query: e.target.value })}
        placeholder="Título, ISBN o SKU..."
        className="module-form-input"
      />
      {matches.length > 0 && (
        <div className="purchases-view__book-results">
          {matches.map(b => (
            <button
              key={b.id}
              type="button"
              onClick={() => onChange({ bookId: b.id, query: b.title }, b)}
              className="purchases-view__book-result"
            >
              <span className="purchases-view__book-title">{b.title}</span>
              <span className="purchases-view__book-meta">{b.isbn}{b.sku ? ` · ${b.sku}` : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
